import { render, staticRenderFns } from "./task-reassign-dialog.vue?vue&type=template&id=01b02003"
import script from "./task-reassign-dialog.vue?vue&type=script&lang=js"
export * from "./task-reassign-dialog.vue?vue&type=script&lang=js"
import style0 from "./task-reassign-dialog.vue?vue&type=style&index=0&id=01b02003&prod&module=true&lang=less"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports